module.exports = __webpack_public_path__ + "img/slides-2.34fd1696.png";